import { useMemo } from 'react'
import { staticState } from '@wellesley/host-remote/common/staticState'

type RendererProps = {
  raw: string
  tag: string
  type: string
}

const useHashTagExtension = (tagPath: string) => {
  const { baseUrl } = staticState.get()

  const absoluteTagPath = useMemo(
    () => (tagPath.startsWith('http') ? tagPath : `${baseUrl}${tagPath}`),
    [baseUrl, tagPath],
  )

  const extension = {
    name: 'hashtag',
    level: 'inline',
    start(src: string) {
      const match = src.match(/(?<!\w)#/)
      return match ? match.index : -1
    },
    tokenizer(src: string) {
      const rule = /^#([\w-]+)/
      const match = rule.exec(src)
      if (match) {
        return {
          type: 'hashtag',
          raw: match[0],
          tag: match[1],
        }
      }
      return undefined
    },
    renderer({ tag }: RendererProps) {
      return `<a class="mention hashtag" href="${absoluteTagPath}${tag}" title="#${tag}" rel="tag">#<span>${tag}</span></a>`
    },
  }

  return extension
}

export default useHashTagExtension
